import { StoreDeliverySettingType } from 'types/storeDeliverySetting'

export const FETCH_STORE_DELIVERY_SETTINGS = 'FETCH_STORE_DELIVERY_SETTINGS'
export const fetchStoreDeliverySettingsAction = (storeDeliverySettings: StoreDeliverySettingType[]) => {
  return {
    type: 'FETCH_STORE_DELIVERY_SETTINGS',
    payload: storeDeliverySettings,
  }
}

export const INIT_STORE_DELIVERY_SETTINGS = 'INIT_STORE_DELIVERY_SETTINGS'
export const initStoreDeliverySettingsAction = () => {
  return {
    type: 'INIT_STORE_DELIVERY_SETTINGS',
    payload: null,
  }
}
